import submit_enter from './components/submit_enter'
import nameshower from './components/nameshower'
import submit from './components/submit'
import naked from './components/submit_enter_naked'
import incdec from './components/incdec'
import nameshower_store from './components/nameshower_store'
import nameshower_store_dork from './components/nameshower_store_dork'
import confirm from './components/confirm'
import submitconfirm from './components/submit_naked_confirm'
import pannes from './components/pannes'


import {makeDOMDriver} from '@motorcycle/dom'
import Cycle from '@cycle/most-run'

import makeStoreDriver from './storedriver'

const apps = {pannes,submit,demo:submit,nameshower,submit_enter,naked,incdec,nameshower_store,confirm,submitconfirm,nameshower_store_dork}
//const apps = {nameshower}

window.attachApps = function(){
	Object.keys(apps).forEach(function(appname){
		var container = document.querySelector('#app_'+appname)
		if (container){
			let sources = {DOM: makeDOMDriver(container)}
			if (true){
				sources.store = makeStoreDriver(appname)
			}
			Cycle.run(apps[appname],sources);
			container.classList.add("app");
		} else {
			console.log("Warning, couldn't find target for app",appname);
		}
	});
}


/** WEBPACK FOOTER **
 ** ./main.js
 **/